export default "\n{% block sw_cms_block_image_cover %}\n<div class=\"sw-cms-block-image-cover\">\n    <slot name=\"image\"></slot>\n</div>\n{% endblock %}\n";